<div class="d-flex">
  <app-chevron-up-icon
    *ngIf="displayChevron"
    [ngClass]="{ clickable: true, 'rotate-180': collapsed }"
    height="auto"
    width="12px"
    color="black"
    (click)="toggleCollapse()"
    (keydown.enter)="toggleCollapse()"
    (keydown.space)="toggleCollapse()"
    tabindex="0"
    role="button"
  />
</div>
